var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoosty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41.5702mm",
    height: "50.0062mm",
    viewBox: "0 0 4159.38 5003.46",
    fill: "none",
    xmlns: "http://www.w3.org/1999/xlink",
    xmlnsxodm: "http://www.corel.com/coreldraw/odm/2003",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "id0",
    gradientUnits: "userSpaceOnUse",
    x1: 2733.44,
    y1: 645.96,
    x2: 1162.51,
    y2: 6470.08
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#EF7829"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0509804,
    style: {
      stopOpacity: 1,
      stopColor: "#F07529"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.360784,
    style: {
      stopOpacity: 1,
      stopColor: "#F0672B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.670588,
    style: {
      stopOpacity: 1,
      stopColor: "#F15E2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#F15A2C"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#id0)",
      fillRule: "nonzero"
    },
    d: "M132.72 2988.84l863.03 -2988.84 1326.32 0 -267.38 926.57c-2.65,5.29 -5.29,10.59 -7.94,15.89l-704.19 2446.13 656.53 0c-275.33,685.66 -489.76,1223.07 -643.31,1612.23 -1212.48,-13.24 -1551.34,-881.56 -1254.84,-1908.73m1260.15 1911.39l1598.99 -2300.54 -677.71 0 590.36 -1474.57c1011.28,105.89 1487.8,902.74 1207.19,1866.37 -299.15,1035.11 -1511.63,1908.73 -2692.34,1908.73 -10.6,0 -18.53,0 -26.48,0z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoosty);
export default __webpack_public_path__ + "static/media/Boosty.7412879df1b69c45bac8e98b21bdda17.svg";
export { ForwardRef as ReactComponent };